"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReviewDeckOptionsWrapper = function ReviewDeckOptionsWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "selected", _descriptor, _this);
      _initializerDefineProperty(_this, "filteredCardCount", _descriptor2, _this);
      // also in interjection_card_wrapper.js
      _initializerDefineProperty(_this, "retiredCount", _descriptor3, _this);
      _initializerDefineProperty(_this, "pastDueCount", _descriptor4, _this);
      _initializerDefineProperty(_this, "caughtUpCount", _descriptor5, _this);
      _initializerDefineProperty(_this, "hideDailyGoalMessage", _descriptor6, _this);
      setTimeout(_this.initialize, 200);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "showStatusAlert",
      get: function get() {
        if (this.due === 'caught-up' && !_state.AppUI.wasUiElementSeen('reviews-caught-up')) {
          return 'caught-up';
        } else if (this.due === 'retired' && !_state.AppUI.wasUiElementSeen('reviews-retired')) {
          return 'retired';
        }
      }
    }, {
      key: "showDailyGoalMessage",
      get: function get() {
        return !this.hideDailyGoalMessage && !_state.AppUI.wasUiElementSeen('dailyGoalReviewAlert') && !this.props.deck.useDailyGoal && this.props.deck.pastDueCount > 100 && !this.props.deck.archived;
      }
    }, {
      key: "onCloseDailyGoalMessage",
      value: function onCloseDailyGoalMessage() {
        this.hideDailyGoalMessage = true;
        _state.AppUI.designateUiElementAsSeen('dailyGoalReviewAlert');
      }
    }, {
      key: "enabledOpenDeck",
      get: function get() {
        return this.cardsCount > 0;
      }
    }, {
      key: "cardTypeId",
      get: function get() {
        return this.selectedOrDeck('card_type_id');
      }
    }, {
      key: "retired",
      get: function get() {
        return this.due === 'retired';
      }
    }, {
      key: "difficultyLabel",
      get: function get() {
        return this.selectedOrDeck('difficulty_label');
      }
    }, {
      key: "createdAtBeforeAfter",
      get: function get() {
        return this.selectedOrDeck('created_at_before_after');
      }
    }, {
      key: "createdAtDaysAgo",
      get: function get() {
        return this.selectedOrDeck('created_at_days_ago');
      }
    }, {
      key: "due",
      get: function get() {
        return this.selectedOrDeck('due');
      }
    }, {
      key: "cardsCount",
      get: function get() {
        if (this.hasAdvancedFilterSelected) {
          return this.filteredCardCount;
        } else if (this.due === 'past-due') {
          return this.pastDueCount;
        } else if (this.due === 'caught-up') {
          return this.caughtUpCount;
        } else if (this.due === 'retired') {
          return this.retiredCount;
        }
      }
    }, {
      key: "cardsText",
      get: function get() {
        if (this.hasAdvancedFilterSelected) {
          return null;
        }
        if (this.due === 'past-due') {
          return 'Past Due';
        } else if (this.due === 'caught-up') {
          return 'Caught Up';
        } else if (this.due === 'retired') {
          return 'Retired';
        }
      }
    }, {
      key: "cardTypeOptions",
      get: function get() {
        var _AppUI$cardTypeStore$;
        return (_AppUI$cardTypeStore$ = _state.AppUI.cardTypeStore.indexData) === null || _AppUI$cardTypeStore$ === void 0 ? void 0 : _AppUI$cardTypeStore$.map(function (item) {
          return [item.id, item.name];
        });
      }
    }, {
      key: "cardTypeString",
      get: function get() {
        var _this$cardTypeId$spli;
        var fullString = (0, _utils.isPresent)(this.cardTypeId) ? (_this$cardTypeId$spli = this.cardTypeId.split(',')) === null || _this$cardTypeId$spli === void 0 || (_this$cardTypeId$spli = _this$cardTypeId$spli.map(function (cardTypeId) {
          var _AppUI$cardTypeStore$2;
          return (_AppUI$cardTypeStore$2 = _state.AppUI.cardTypeStore.indexData.find(function (item) {
            return item.id === cardTypeId;
          })) === null || _AppUI$cardTypeStore$2 === void 0 ? void 0 : _AppUI$cardTypeStore$2.name;
        })) === null || _this$cardTypeId$spli === void 0 ? void 0 : _this$cardTypeId$spli.join(', ') : null;
        var maxLength = 75;
        return (0, _utils.isPresent)(fullString) && _state.AppUI.cardTypeStore.hasIndexData ? "Card Types: ".concat(fullString.length > maxLength ? "".concat(fullString.substring(0, maxLength), "...") : fullString) : null;
      }
    }, {
      key: "createdAtString",
      get: function get() {
        if ((0, _utils.isPresent)(this.createdAtDaysAgo) && this.createdAtBeforeAfter === 'before') {
          return "Created Before ".concat(this.createdAtDaysAgo, " Days Ago");
        } else if ((0, _utils.isPresent)(this.createdAtDaysAgo)) {
          return "Created Last ".concat(this.createdAtDaysAgo, " Days");
        }
      }
    }, {
      key: "difficultyLabelString",
      get: function get() {
        var _this2 = this;
        return (0, _utils.isPresent)(this.difficultyLabel) ? _constants.Constants.DIFFICULTY_LABEL_OPTIONS.find(function (item) {
          return item[0] === _this2.difficultyLabel;
        })[1] : null;
      }
    }, {
      key: "hasAdvancedFilterSelected",
      get: function get() {
        var _this$filterSettings;
        return (0, _lodash.some)((_this$filterSettings = this.filterSettings) === null || _this$filterSettings === void 0 ? void 0 : _this$filterSettings.map(function (item) {
          return (0, _utils.isPresent)(item.value);
        }));
      }
    }, {
      key: "selectedOrDeck",
      value: function selectedOrDeck(key) {
        if (key in this.selected) {
          return this.selected[key];
        } else {
          return this.props.deck[(0, _utils.toCamelCase)("reviews_filter_".concat(key))];
        }
      }
    }, {
      key: "gotoReviewIndex",
      value: function gotoReviewIndex(deckId, type) {
        var data = {
          reviewsFilterDeckId: deckId,
          reviewsFilterCardTypeId: null,
          reviewsFilterRetired: type === 'retired',
          reviewsFilterDue: type === 'retired' ? null : type
        };
        this.updateUser(data);
      }
    }, {
      key: "updateUser",
      value: function updateUser(data) {
        (0, _lodash.each)((0, _lodash.keys)(data), function (key) {
          _state.AppUI.user.set(key, data[key]);
        });
        _state.AppUI.authUserStore.update({
          data: data
        }, this.routeToReviewsIndex);
      }
    }, {
      key: "routeToReviewsIndex",
      value: function routeToReviewsIndex() {
        if (_state.AppUI.layout.isNative) {} else {
          _state.AppUI.routeStore.routeToNamed('reviews.index');
        }
      }
    }, {
      key: "onSetFilter",
      value: function onSetFilter(key, value) {
        if (value === 'RANGE[,]') {
          value = null;
        }
        this.selected[key] = value;
        this.getCardsCount();
      }
    }, {
      key: "onSetCardTypeId",
      value: function onSetCardTypeId(val) {
        var ary = (0, _utils.isPresent)(this.cardTypeId) ? this.cardTypeId.split(',') : [];
        if ((0, _lodash.isEmpty)(val)) {
          ary = [];
        } else if (ary.includes(val)) {
          ary = ary.filter(function (item) {
            return item !== val;
          });
        } else {
          ary.push(val);
        }
        this.onSetFilter('card_type_id', ary.join(','));
      }
    }, {
      key: "onSetCreatedFilter",
      value: function onSetCreatedFilter(value, key) {
        if ((0, _utils.isBlank)(key)) {
          key = 'created_at_days_ago';
        }
        this.onSetFilter(key, value);
      }
    }, {
      key: "afterGetCardsCount",
      value: function afterGetCardsCount(resp) {
        this.filteredCardCount = resp.count;
        this.pastDueCount = resp.pastDueCount;
        this.retiredCount = resp.retiredCount;
        this.caughtUpCount = resp.reviewCardsCount - resp.pastDueCount - resp.retiredCount;
      }
    }, {
      key: "initialize",
      value: function initialize() {
        if (!_state.AppUI.cardTypeStore.hasIndexData) {
          _state.AppUI.cardTypeStore.getIndex({
            filters: {
              allow_reviews: true
            },
            sort: 'position'
          });
        }
        this.getCardsCount();
      }
    }, {
      key: "getCardsCount",
      value: function getCardsCount() {
        this.filteredCardCount = null;
        var filters = {
          card_type_id: this.cardTypeId,
          retired: this.retired,
          difficulty_label: this.difficultyLabel,
          created_at_before_after: this.createdAtBeforeAfter,
          created_at_days_ago: this.createdAtDaysAgo,
          due: this.due
        };
        _state.AppUI.deckStore.cardsCount({
          ids: {
            deckId: this.props.deck.id
          },
          data: {
            filters: filters
          }
        }, this.afterGetCardsCount);
      }
    }, {
      key: "onToggleExpandOptions",
      value: function onToggleExpandOptions() {
        this.expandOptions = !this.expandOptions;
      }
    }, {
      key: "onOpenDeck",
      value: function onOpenDeck() {
        if (!this.enabledOpenDeck) {
          return;
        }
        _state.AppUI.routeStore.routeToNamed('reviews.decks.show', {
          deckId: this.props.deck.id
        });
      }
    }, {
      key: "onChangeDifficultyLabel",
      value: function onChangeDifficultyLabel(difficultyLabel) {
        this.onSetFilter('difficulty_label', difficultyLabel);
      }
    }, {
      key: "onClickStatus",
      value: function onClickStatus(status) {
        if (status === this.due) {
          return;
        }
        if (status === 'past-due') {
          this.onSetFilter('due', 'past-due');
        } else if (status === 'caught-up') {
          this.onSetFilter('due', 'caught-up');
        } else if (status === 'retired') {
          this.onSetFilter('due', 'retired');
        }
      }
    }, {
      key: "closeStatusAlert",
      value: function closeStatusAlert(statusAlert) {
        if (statusAlert === 'retired') {
          _state.AppUI.designateUiElementAsSeen('reviews-retired');
        } else if (statusAlert === 'caught-up') {
          _state.AppUI.designateUiElementAsSeen('reviews-caught-up');
        }
      }
    }, {
      key: "filterSettings",
      get: function get() {
        return [{
          name: 'Review Types',
          type: 'InPlaceSelect',
          options: [['past-due', 'Past Due'], ['caught-up', 'Caught Up'], ['retired', 'Retired']],
          value: this.due,
          onChange: this.onClickStatus,
          placeholder: 'All Review Types',
          webOnly: true
        }, {
          name: 'Card Types',
          type: 'MultiSelect',
          options: this.cardTypeOptions,
          value: this.cardTypeId,
          onChange: this.onSetCardTypeId,
          placeholder: 'All Card Types',
          tagDisplay: this.cardTypeString,
          maxOptions: 3
        }, {
          name: 'Created',
          type: 'CreatedAt',
          value: {
            createdAtBeforeAfter: this.createdAtBeforeAfter,
            createdAtDaysAgo: this.createdAtDaysAgo
          },
          onChange: this.onSetCreatedFilter,
          placeholder: 'All Card Types',
          tagDisplay: this.createdAtString,
          webOnly: true
        }, {
          name: 'Created',
          type: 'InPlaceSelect',
          value: this.createdAtDaysAgo,
          options: [[1, 'Last Day'], [7, 'Last 7 Days'], [30, 'Last 30 Days'], [90, 'Last 90 Days']],
          onChange: this.onSetCreatedFilter,
          placeholder: 'All Card Types',
          tagDisplay: this.createdAtString,
          nativeOnly: true
        }, {
          name: 'Difficulty',
          type: 'InPlaceSelect',
          options: _constants.Constants.DIFFICULTY_LABEL_OPTIONS,
          value: this.difficultyLabel,
          onChange: this.onChangeDifficultyLabel,
          placeholder: 'Any',
          tagDisplay: this.difficultyLabelString
        }];
      }
    }, {
      key: "webFilterSettings",
      get: function get() {
        return this.filterSettings.filter(function (item) {
          return !item['nativeOnly'];
        });
      }
    }, {
      key: "nativeFilterSettings",
      get: function get() {
        return this.filterSettings.filter(function (item) {
          return !item['webOnly'];
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          cardTypeId: this.cardTypeId,
          onSetFilter: this.onSetFilter,
          cardTypeOptions: this.cardTypeOptions,
          cardsCount: this.cardsCount,
          enabledOpenDeck: this.enabledOpenDeck,
          onOpenDeck: this.onOpenDeck,
          retired: this.retired,
          due: this.due,
          gotoReviewIndex: this.gotoReviewIndex,
          onClickStatus: this.onClickStatus,
          hasAdvancedFilterSelected: this.hasAdvancedFilterSelected,
          cardsText: this.cardsText,
          showStatusAlert: this.showStatusAlert,
          closeStatusAlert: this.closeStatusAlert,
          retiredCount: this.retiredCount,
          pastDueCount: this.pastDueCount,
          caughtUpCount: this.caughtUpCount,
          webFilterSettings: this.webFilterSettings,
          nativeFilterSettings: this.nativeFilterSettings,
          showDailyGoalMessage: this.showDailyGoalMessage,
          onCloseDailyGoalMessage: this.onCloseDailyGoalMessage
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "filteredCardCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "retiredCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "pastDueCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "caughtUpCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "hideDailyGoalMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "showStatusAlert", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showStatusAlert"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showDailyGoalMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showDailyGoalMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCloseDailyGoalMessage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCloseDailyGoalMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "enabledOpenDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "enabledOpenDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "retired", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "retired"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "difficultyLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "difficultyLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdAtBeforeAfter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "createdAtBeforeAfter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdAtDaysAgo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "createdAtDaysAgo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "due", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "due"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardsCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardsText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardsText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdAtString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "createdAtString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "difficultyLabelString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "difficultyLabelString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasAdvancedFilterSelected", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasAdvancedFilterSelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedOrDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedOrDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "gotoReviewIndex", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "gotoReviewIndex"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateUser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "routeToReviewsIndex", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "routeToReviewsIndex"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetCardTypeId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetCardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetCreatedFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetCreatedFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetCardsCount", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetCardsCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "initialize", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "initialize"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getCardsCount", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getCardsCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleExpandOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleExpandOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onOpenDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onOpenDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeDifficultyLabel", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeDifficultyLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickStatus", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickStatus"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "closeStatusAlert", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "closeStatusAlert"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "webFilterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "webFilterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nativeFilterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "nativeFilterSettings"), _class2.prototype), _class2)) || _class;
};
ReviewDeckOptionsWrapper.displayName = 'ReviewDeckOptionsWrapper';
var _default = exports["default"] = ReviewDeckOptionsWrapper;